module.exports = __webpack_public_path__ + "static/media/tdo_logo.90b7c07e.png";